import React from 'react'
import Layout from './pages/Layout'
import { BrowserRouter, Route, Routes, Navigate} from 'react-router'
import LogoutPage from '@shared/pages/LogoutPage'
import AuthPage from '@shared/pages/AuthPage'
import LogoutSuccessPage from './pages/LogoutSuccessPage'
import ErrorPage from './pages/ErrorPage'
import PrivateApp from './PrivateApp'
import CguPage from "./pages/cgu/CguPage";
import moment from 'moment'
import 'moment/locale/fr'
import WelcomePage from "./pages/WelcomePage.jsx";
import SimulationPage from "./pages/simulation/SimulationPage.jsx";
import SimulationForm from "./pages/simulation/SimulationForm.jsx";
import SimulationSuccess from "./pages/simulation/SimulationSuccess.jsx";
import SimulationFailed from "./pages/simulation/SimulationFailed.jsx";
import FaqPage from "./pages/faq/FaqPage.jsx";
import ContactPage from "./pages/ContactPage.jsx";
import ContactInformationPage from "./pages/ContactInformationPage.jsx";
import RecordPage from "./pages/record/RecordPage.jsx";
import DeclarationPage from "./pages/declaration/DeclarationPage.jsx";
import NotificationPage from "./pages/welcome/NotificationPage.jsx";
import ApproveConsentPage from "./pages/welcome/ApproveConsentPage.jsx";
import DeclarationDetail from "./pages/declaration/DeclarationDetail.jsx";
import DeclarationForm from "./pages/declaration/DeclarationForm.jsx";
import ChildInfo from "./pages/record/ChildInfo.jsx";
import EmployeeContact from "./pages/record/EmployeeContact.jsx";
import RecordAttachment from "./pages/record/RecordAttachment.jsx";
import RecordSignature from "./pages/record/RecordSignature.jsx";
import RecordSent from "./pages/record/RecordSent.jsx";
moment.locale('fr')


function App() {
  if (window.location.pathname === '/') {
    window.location.replace('/beneficiary')
    return null
  }
  return (
    <BrowserRouter basename={ '/beneficiary' }>
      <Layout>
        <Routes>
          <Route path="/auth" element={ <AuthPage root="/beneficiary" /> } />
          <Route path="/logout" element={ <LogoutPage /> } />
          <Route path="/logout-success" element={ <LogoutSuccessPage /> } />
          <Route path="/error/:status" element={ <ErrorPage /> } />
          <Route path="/cgu" element={ <CguPage /> } />
          <Route element={<PrivateApp />}>
            <Route index element={ <WelcomePage /> }/>
            <Route path="/simulation" element={ <SimulationPage simulationOnly={true} /> }>
              <Route index element={ <SimulationForm /> }/>
              <Route path="success" element={ <SimulationSuccess /> }/>
              <Route path="failed" element={ <SimulationFailed /> }/>
            </Route>
            <Route path="/deposit" element={ <SimulationPage /> }>
              <Route index element={ <SimulationForm /> }/>
              <Route path="success" element={ <SimulationSuccess /> }/>
              <Route path="failed" element={ <SimulationFailed /> }/>
            </Route>
            <Route path="/faq" element={ <FaqPage /> }/>
            <Route path="/contact" element={ <ContactPage /> }/>
            <Route path="/contactInformation" element={ <ContactInformationPage /> }/>
            <Route path="/record/:id" element={ <RecordPage /> }>
              <Route index element={ <ChildInfo /> }/>
              <Route path="child-info" element={ <ChildInfo /> }/>
              <Route path="employee-contact" element={ <EmployeeContact /> }/>
              <Route path="attachment" element={ <RecordAttachment /> }/>
              <Route path="signature" element={ <RecordSignature /> }/>
              <Route path="record-sent" element={ <RecordSent /> }/>
            </Route>
            <Route path="/declaration/:id" element={ <DeclarationPage /> }>
              <Route index element={ <DeclarationDetail /> } />
              <Route path="declare" element={ <DeclarationForm /> } />
            </Route>
            <Route path="/notifications/:id" element={ <NotificationPage />} />
            <Route path="/consent" element={ <ApproveConsentPage /> } />
          </Route>
          <Route path="*" element={ <ErrorPage /> } />
        </Routes>
      </Layout>
    </BrowserRouter>
  )
}

export default App
